import "../Styles/main.scss";
import "./index.scss";
import "../../components/cmsShared";
import "jquery.cookie";
import { Slick } from "@/pages/vendors/vendor.slick";


$(function () {
    function initProductBannerSlides($productBannerSlides: JQuery) {
        if ($productBannerSlides.find("m-product-detail__info-slide-imgs-item").length) {
            new Slick($productBannerSlides, {
                swipe: true,
                dots: false,
                autoplay: true,
                infinite: true,
                speed: 500,
                fade: false,
                arrows: false,
            });
        }
    }
    const $productBannerSlides = $("m-product-detail__info-slide-imgs");
    initProductBannerSlides($productBannerSlides);
   
    $("#product-sort").find("li").click(function(){
            var sort = $(this).data("sort");
           $.cookie('fht_product_sort',sort, { expires: 1 });   
           location.reload();       
    });
});